import React from "react"
import { Grid, TextField } from "@material-ui/core"

import BlockBodySectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionEditor"

import useContentEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useContentEditor"

import { ChatBotFlowBlockContent } from "@/protocols/chatBot"

type APIUrlSectionEditorProps = {
	onSave: (chatBotFlowBlockContent: ChatBotFlowBlockContent) => void
	chatBotFlowBlockContent: ChatBotFlowBlockContent
}

const APIUrlSectionEditor: React.FC<APIUrlSectionEditorProps> = (props) => {
	const {
		chatBotFlowBlockContent,
		onSave,
		children
	} = props

	const contentEditor = useContentEditor({ chatBotFlowBlockContent })

	return (
		<BlockBodySectionEditor
			title="DEFINIR URL DA API DO AGENTE"
			onSave={() => onSave(contentEditor.content)}
			onOpen={contentEditor.reset}
			AsideDrawerProps={{
				children: (
					<Grid
						container
						spacing={2}
					>
						<Grid
							item
							xs={12}
						>
							<TextField
								value={contentEditor.content?.aiAgentAPI?.apiUrl}
								defaultValue={chatBotFlowBlockContent?.aiAgentAPI?.apiUrl}
								onChange={({ target }) => (
									contentEditor.changeContent({
										aiAgentAPI: {
											apiUrl: target.value
										}
									})
								)}
								variant="outlined"
								color="primary"
								multiline
								fullWidth
								placeholder="https://n8n.example.com/webhook/agent-api"
							/>
						</Grid>
					</Grid>
				)
			}}
		>
			{children}
		</BlockBodySectionEditor>
	)
}

export default APIUrlSectionEditor
